<template>
  <div>
    <el-dialog
        title="Create Code"
        :visible.sync="showCodeDialog">

      <p>Email address</p>
      <el-input v-model="codeDetails.email"></el-input>

      <el-button v-on:click="createCode">Create</el-button>
    </el-dialog>
    <el-button v-on:click="enableCodeDialog" type="primary" style="margin-bottom:20px;">Create code</el-button>
    <el-button v-on:click="downloadCsv" style="margin-bottom:20px;">Download CSV</el-button>

    <el-table
      :data="referral_codes"
      style="width: 100%">
      <el-table-column
          prop="email"
          label="Email"
          sortable>
      </el-table-column>
      <el-table-column
          prop="status_pretty"
          label="Code Status"
          sortable>
        <template slot-scope="scope">
          <el-tag
              :type="scope.row.status_color"
              disable-transitions>{{scope.row.status_pretty}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="paid_subscription"
          label="Subscription"
          sortable>
      </el-table-column>
      <el-table-column
          prop="creator_pretty"
          label="Created by"
          sortable>
      </el-table-column>
      <el-table-column
          prop="created_at_pretty"
          label="Created">
      </el-table-column>
      <el-table-column
            prop="updated_at_pretty"
            label="Last activity">
      </el-table-column>
      <el-table-column
          prop="code"
          label="Referral code">
      </el-table-column>
      <el-table-column
          prop="pricing_url"
          label="Pricing URL">
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
export default {
  name: "ReferralCodes",
  props: ['org_id_from_blade'],
  computed: {},
  data() {
    return {
      referral_codes: null,
      showCodeDialog: false,
      codeDetails: {}
    }
  },
  mounted() {
      this.getCodes()
  },
  methods: {
    enableCodeDialog() {
        this.showCodeDialog = true
    },
    downloadCsv() {
      window.open('/api/referrals/codes/csv/' + this.org_id_from_blade,"_blank")
    },
    createCode() {
      axios.post('/api/referrals/codes/' + this.org_id_from_blade, {
        details: this.codeDetails,
      }).then(response => {
        // success
        this.getCodes()
      }).catch(error => {
        // console.log('oops starting job chain')
        // console.log(response)
      })
      this.showCodeDialog = false
    },
    getCodes() {
      axios.get('/api/referrals/codes/' + this.org_id_from_blade)
          .then(response => {
            this.referral_codes = response.data
          })
    }
  }
}
</script>

<style scoped>

</style>